<template>  
    <vuescroll>
      <div class="box-border m-8">
          <div class="m-2">
            <Header>
              <template v-slot:title>Sobre mí</template>
              <template v-slot:subtitle>Estudios y trabajo</template>
            </Header>
            <PersonalData/>
            <div class="flex flex-col flex-1 lg:flex-row">
              <TimelineJob class="flex-1"/>
              <TimelineEducate class="flex-1"/>
            </div>
            <Skills class="mt-8"/>
          </div>
      </div>
    </vuescroll>
</template>

<script>
import vuescroll from "vuescroll";
import Header from "../components/Header.vue";
import PersonalData from "../components/PersonalData.vue";
import TimelineJob from "../components/TimelineJob.vue";
import TimelineEducate from "../components/TimelineEducate.vue";
import Skills from "../components/Skills.vue";
import data from '../data/experience'

export default {
  components: {
    vuescroll,
    Header,
    PersonalData,
    TimelineJob,
    Skills,
    TimelineEducate
  },
  data() {
    return {
      data: data
    }
  }
};
</script>

<style scoped>
  #timeline-job:before {
    content:'';
    position: absolute;
    width: 0;
    left: 1px;
    top: 0;
    bottom: 0;
    border-right: 1px solid rgba(0, 0, 0, .2);
  }
  #timeline-job:after {
    content:'';
    position: absolute;
    width: 4px;
    height: 4px;
    left: 0;
    margin-top: -4px;
    background-color: var(--color-primary);
  }
</style>
